import AbstractListView from '@UI/Store/AbstractListView';
import type RoleView from '@UI/Store/Roles/Views/RoleView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Feeds the user-management role selector: the account's whole role catalogue, unfiltered — distinct
 * from `RolesListView`, which is the Roles screen's own filtered, paginated list.
 */
class AccountRolesListView extends AbstractListView<RoleView> {
	readonly accountId: number;
	readonly totalRecords: number;

	constructor(list: readonly RoleView[], accountId: number, totalRecords: number) {
		super(list, 'AccountRolesListView');

		this.accountId = accountId;
		this.totalRecords = totalRecords;

		Object.freeze(this);
	}
}

export default AccountRolesListView;
